import { Pipe, PipeTransform } from '@angular/core';
import { makeTranslateService } from '../../../data/services/common/translate/translate-service-factory';
import { LanguageKey } from '../../../main/translate/language-key/language-key';

@Pipe({
  name: 'translateKey',
  pure: false,
  standalone: true,
})
export class TranslateKeyPipe implements PipeTransform {
  translateService = makeTranslateService();

  transform(key: LanguageKey | string | null | undefined): string {
    if (!key) {
      return '';
    }

    try {
      return this.translateService.translateKey(key as LanguageKey);
    } catch {
      return String(key);
    }
  }
}
